export const TOOLTIP_WIDTH = 300;
export const FIND_TARGET_RETRIES = 15;
export const FIND_TARGET_DELAY = 200;

const GAP = 12;
const VIEWPORT_PAD = 16;
const NAVBAR_HEIGHT = 64;

export function computeTooltipPosition(targetRect, placement, tooltipHeight) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  let top, left;

  switch (placement) {
    case 'bottom':
      top = targetRect.bottom + GAP;
      left = targetRect.left + targetRect.width / 2 - TOOLTIP_WIDTH / 2;
      break;
    case 'top':
      top = targetRect.top - tooltipHeight - GAP;
      left = targetRect.left + targetRect.width / 2 - TOOLTIP_WIDTH / 2;
      break;
    case 'left':
      top = targetRect.top + targetRect.height / 2 - tooltipHeight / 2;
      left = targetRect.left - TOOLTIP_WIDTH - GAP;
      break;
    case 'right':
      top = targetRect.top + targetRect.height / 2 - tooltipHeight / 2;
      left = targetRect.right + GAP;
      break;
    default:
      top = targetRect.bottom + GAP;
      left = targetRect.left + targetRect.width / 2 - TOOLTIP_WIDTH / 2;
  }

  left = Math.max(
    VIEWPORT_PAD,
    Math.min(left, vw - TOOLTIP_WIDTH - VIEWPORT_PAD)
  );
  top = Math.max(
    NAVBAR_HEIGHT + VIEWPORT_PAD,
    Math.min(top, vh - tooltipHeight - VIEWPORT_PAD)
  );

  return { top, left };
}

export function highlightTourTarget(selector, highlight) {
  document.querySelectorAll('[data-tour-highlighted]').forEach((el) => {
    el.removeAttribute('data-tour-highlighted');
    el.style.removeProperty('--tour-box-shadow');
    el.style.removeProperty('--tour-border-radius');
    el.style.removeProperty('--tour-padding');
  });
  if (!selector) return;
  const el = document.querySelector(selector);
  if (!el) return;
  el.setAttribute('data-tour-highlighted', '');
  if (highlight && typeof highlight === 'object') {
    if (highlight.boxShadow) {
      el.style.setProperty('--tour-box-shadow', highlight.boxShadow);
    }
    if (highlight.borderRadius) {
      el.style.setProperty('--tour-border-radius', highlight.borderRadius);
    }
    if (highlight.padding) {
      el.style.setProperty('--tour-padding', highlight.padding);
    }
  }
}
